import Image from "next/image";

const data = [
  {
    title: "گواهینامه پایان دوره",
    image: "https://faradars.org/wp-content/uploads/2025/07/20/گواهینامه.svg",
  },
  {
    title: "هزاران ساعت آموزش",
    image: "https://faradars.org/wp-content/uploads/2025/07/20/ساعت-آموزش.svg",
  },
  {
    title: "دسترسی آنی و همیشگی",
    image: "https://faradars.org/wp-content/uploads/2025/07/20/دسترسی-آنی.svg",
  },
  {
    title: "تضمین کیفیت آموزش‌ها",
    image: "https://faradars.org/wp-content/uploads/2025/07/20/تضمین-کیفیت.svg",
  },
];

const Values: React.FC = () => {
  return (
    <>
      <div className="py-8 bg-fds-canvas-secondary">
        <div className="mx-auto grid grid-cols-2 lg:grid-cols-4 footer-properties-sizing">
          {data.map((item, i) => (
            <div
              key={i}
              className="flex flex-col justify-center gap-2  items-center w-full"
            >
              <Image width={60} height={48} src={item.image} alt={item.title} />
              <p className="w-full text-center text-fds-primary text-sm font-medium">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Values;
